<template>
  <div class="footer">
    <div class="foot container">
      <div class="row justify-content-center">
        <div class="foot0 col-md-2 col-lg-2 col-xl-2">
            <img class="logo_img" :src="base_url+data.logo.url" alt="">
        </div>
        <div class="foot1  col-md-6 col-lg-6 col-xl-3"><span class="zxd1">咨询电话</span>
          <h4>{{ data.tel }}</h4>
          <h4 class="bd11">{{ data.phone_number }}</h4>
          <span class="lxd1">联系方式</span>
          <p>QQ: {{ data.qq }}</p>
          <p>地址: {{ data.address }}</p>
          <p>投诉邮箱：{{ data.email }}</p>
        </div>
        <div class="foot2  col-xl-5 d-none d-lg-block">
          <dl v-for="item in lists" :key="item.id">
            <dd><a :href="'/nav/list/'+item.id"> {{item.name}}</a></dd>
            <dt v-for="citem in item.children" :key="citem.id"> <a :href="'/nav/list/'+citem.id">{{ citem.name }}</a></dt>
          </dl>
        </div>
        <div class="foot3  col-md-4 col-lg-6 col-xl-2">
          <h3>扫码关注公众号</h3>
          <img :src="base_url+data.wechat_qr_img.url">
          <p>关注我们了解更多资讯</p>
          <!--        <span id="llcs">网站浏览:421574次</span>-->
        </div>
        <div class="clear"></div>
      </div>
    </div>

    <div class="footer1">{{data.copyright}} 备案号:<a href="https://beian.miit.gov.cn/"
                                                target="_blank"
                                                rel="nofollow">{{ data.icp_record }}</a><span>
    </span></div>


  </div>
<!--  <div class="side-bar">
    <div class="bdh566">
      <a href="http://wpa.qq.com/msgrd?v=3&amp;uin=2546874082&amp;site=qq&amp;menu=yes" target="_blank"><img
          src="">在线客服</a>
      <li><img src="">官方微信
        <div class="chat-tips wx19"><img
            :src="base_url+data.wechat_qr_img">
          <p>微信扫一扫关注</p></div>
      </li>
      <li><img src="">客服电话
        <div class="chat-tips">{{ data.tel }}<i></i></div>
      </li>
      <li><img src="">24小时热线
        <div class="chat-tips">{{ data.phone_number }}<i></i></div>
      </li>
      <li><img src="">资料投递
        <div class="chat-tips" style="font-size:12px;">{{ data.email }}<i></i></div>
      </li>
    </div>
    <a href="/#top"><img src="">返回顶部</a>
  </div>-->
</template>
<script>
import {getNavs} from "@/api/home";
import {handleNavData} from "@/utils"

export default {
  props: {
    initData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  watch: {
    initData: {
      handler(v) {
        this.data = v
      },
      deep: true
    }
  },
  data() {
    return {
      base_url:process.env.VUE_APP_BASE_API,
      data:{
        tel: '',
        phone_number: '',
        qq: '',
        email: '',
        address: '',
        icp_record: '',
        copyright:'',
        wechat_qr_img:'',
        logo:''
      },
      lists:[]
    }
  },
  created() {
    this.getList()
  },
  methods:{
    getList(){
      const temp = {is_bottom_show:true}
      getNavs(temp).then((response)=>{
        this.lists = handleNavData(response)
      })
    }
  }
}
</script>
<style>
.foot0{
  padding: .5rem 0;
}
.logo_img{
  display: block;
  margin: 0 auto;
 /* width: 10rem;
  height: 10rem;*/
  border-radius: 50%;
}
</style>